export default __webpack_public_path__ + "static/media/sidenav-card-background.00019e46.png";